/* Global imports. */
import React from "react";
import { Link } from "gatsby"
import { ImageElement } from "@kontent-ai/gatsby-components";


import LinkWrapper from "@components/LinkWrapper"
import SearchBar from "@components/SearchBar"
import LatestArticles from "@components/LatestArticles";
import NewsletterHelper from "@components/NewsletterHelper"
import HeaderLogo from "@components/HeaderLogo"

import FacebookIcon from "@images/icon--facebook.svg";
import InstagramIcon from "@images/icon--instagram.svg";
import TwitterIcon from "@images/icon--twitter.svg";
import TikTokIcon from "@images/icon--tiktok.png";
import YouTubeIcon from "@images/icon--youtube.png";
import SoundcloudIcon from "@images/icon--soundcloud.png"

class MegaMenu extends React.Component {
  constructor(props) {
    super(props);
      this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
      this.state = {
        mobileMenuVisible: false,
        megaNavSliderPanelActive: 0
      };
  }

  

  componentDidMount() {
    this.setState({mobileMenuVisible: false})
    document.body.style.overflow = '';
  }

  toggleSliderNode(i) {
    this.setState({ megaNavSliderPanelActive: i, });
  }

  toggleMobileMenu() {
    if(!this.state.mobileMenuVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    this.setState({
      mobileMenuVisible: !this.state.mobileMenuVisible,
    });

    /* IMPORTED JS */

    var getArrayOfElements = function getArrayOfElements(str) {
      return Array.prototype.slice.call(document.querySelectorAll(str));
    };

    const meganavTriggers = getArrayOfElements('.js-meganav-trigger'), 
    meganavBackBtns = getArrayOfElements('.js-nav-back'),
    exapandablePanels = Array.from(document.querySelectorAll('.js-expandable-panel'))

    var createMegaNavListeners = function createMegaNavListeners(arr) {
        arr.forEach(function(a) {
            a.addEventListener('click', function() {
                a.closest('.js-meganav-parent').classList.add('nav-links-list__item--meganav--open');
            });
        });
       
    };

    var removeActiveClassFromArrItems = function removeActiveClassFromArrItems(arr, classToRemove) {
      return new Promise(function(resolve) {
          arr.forEach(function(a) {
              a.classList.remove(classToRemove);
          });
          resolve();
        }
      );
    };

    var createSubNavListeners = function createSubNavListeners(arr, activeClass, siblingClass, siblingActiveClass, parent) {
      var animationDelay = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 300;
      arr.forEach(function(a) {
          a.addEventListener('click', function() {
              arr.forEach(function(b) {
                  b.classList.remove(activeClass);
              });
              a.classList.add(activeClass);
              removeActiveClassFromArrItems(Array.from(parent.querySelectorAll(siblingClass)), siblingActiveClass).then(function() {
                  setTimeout(function() {
                      a.parentNode.querySelector(siblingClass).classList.add(siblingActiveClass);
                  }, animationDelay);
              });
          });
      });
    };

    var navDropdownGroups = Array.from(document.querySelectorAll('.js-meganav-parent'));

    navDropdownGroups.forEach(function(arr) {
      createSubNavListeners(Array.from(arr.querySelectorAll('.js-meganavlistitem-trigger')), 'meganav-list__item-trigger--active', '.js-meganavlistitem', 'meganav-list__sublist--active', arr);
    });

    var createBackListeners = function createBackListeners(arr) {
      arr.forEach(function(a) {
          a.addEventListener('click', function() {
              a.closest('.js-meganav-parent').classList.remove('nav-links-list__item--meganav--open');
          });
      });
    };

    var mapExpandPanels = function mapExpandPanels(arr) {
        arr.forEach(function(a) {
          a.querySelector('h3').addEventListener('click', function() {
              a.classList.toggle('expandable-panel--open');
          });
      });

    };

    var init = function init() {
      createMegaNavListeners(meganavTriggers);
      createBackListeners(meganavBackBtns);
      mapExpandPanels(exapandablePanels);
    };

    init();

  }

 
  
  render() {
    const classNav = (this.state.mobileMenuVisible ? 'nav--trade nav--mobile-open' : 'nav--trade')
    const navItems = this.props.navItems
    const alphabet = "abcdefghijklmnopqrstuvwxyz".split("")
    const articleCategories = this.props.articleCategories
    const featuredContributors = this.props.featuredContributors.featured_contributors && this.props.featuredContributors.featured_contributors.value
    const featuredContributorsHeading = this.props.featuredContributors.featured_contributors_heading && this.props.featuredContributors.featured_contributors_heading.value
    const dontmissNavigationItems = this.props.dontmiss && this.props.dontmiss.elements && this.props.dontmiss.elements.linked_item && this.props.dontmiss.elements.linked_item.value
    const dontmiss = this.props.dontmiss
    const social = this.props.social
    const mailchimp = this.props.mailchimp    

    function dontMissBlock () {
      return (
        <>
        <p className="mt-4 mb-2 font-sans font-bold text-left">{dontmiss && dontmiss.title && dontmiss.title.value ? dontmiss.title.value : `Don't Miss`}</p>
          <ul>
            {dontmissNavigationItems.map((item, i) => {
              return <li key={`dontmiss-${item.elements.url_slug.value}`} className="meganav-list__sublist-item"><LinkWrapper url={`/${item.elements.url_slug.value}`} text={item.elements.title.value} cssClass="no-underline hover:text-link" /></li>
            })}
          </ul>
        </>
      )
    }

    function socialIcons (item) {
      return (
        <ul className="social-bar">
          {social.facebook && <li key={`megamenu_n1_${item.id}`} className="mr-4 sans max-w-8"><a href={social.facebook} data-social="Facebook" className="js-follow" target="_blank" rel="noopener noreferrer"> <img alt="Facebook" title="Facebook" src={FacebookIcon} width="32" height="32" className="optanon-category-C0004"/> Facebook</a></li>}
          {social.instagram && <li key={`megamenu_n2_${item.id}`} className="mr-4 sans max-w-8"><a href={social.instagram} data-social="Instagram" className="no-underline js-follow" target="_blank" rel="noopener noreferrer"><img alt="Instagram" title="Instagram" className="" src={InstagramIcon} width="32" height="32" /> Instagram</a></li>}
          {social.twitter && <li key={`megamenu_n3_${item.id}`} className="mr-4 sans max-w-8"><a href={social.twitter} data-social="Twitter" className="no-underline js-follow" target="_blank" rel="noopener noreferrer"><img alt="X (Twitter)" title="X (Twitter)" className="flex items-center justify-center bg-black rounded-2xl w-8 h-8 p-2 overflow-visible" src={TwitterIcon} width="32" height="32" /> X (Twitter)</a></li>}
          {social.tiktok && <li key={`megamenu_n4_${item.id}`} className="mr-4 sans max-w-8"><a href={social.tiktok} data-social="TikTok" className="no-underline js-follow" target="_blank" rel="noopener noreferrer"><img alt="TikTok" title="TikTok" className="" src={TikTokIcon} width="32" height="32" /> TikTok</a></li>}
          {social.soundcloud && <li key={`megamenu_n5_${item.id}`} className="mr-4 sans max-w-8"><a href={social.soundcloud} data-social="Soundcloud" className="no-underline js-follow" target="_blank" rel="noopener noreferrer"><img alt="Soundcloud" title="Soundcloud" className="" src={SoundcloudIcon} width="32" height="32" /> Soundcloud</a></li>}
          {social.youtube && <li key={`megamenu_n6_${item.id}` } className="mr-4 sans max-w-8"><a href={social.youtube} data-social="YouTube" className="no-underline js-follow" target="_blank" rel="noopener noreferrer"><img alt="YouTube" title="YouTube" className="" src={YouTubeIcon} width="32" height="32" /> YouTube</a></li>}
        </ul>
      )
    }

    return (
      <nav className={classNav}>
      <div className="container-main">
        <ul className="nav-list">
          <li key={`megamenu_k`} className="nav-list__logo js-logo">
            <Link to="/" aria-label="Home">
              <HeaderLogo />
            </Link>
          </li>
          
          <li key={`megamenu_l`} className="nav-list__links xl:h-full">
            <ul className="nav-links-list xl:h-full">
              {navItems.map((item, i) => {
               if(item && item.elements && item.elements.linked_item !== undefined && item.elements.linked_item.value.length > 0 && item.elements.linked_item.value[0].elements && item.elements.linked_item.value[0].elements.linked_item !== undefined && item.elements.linked_item.value[0].elements.linked_item.value.length > 0) {
                  const subItems = item.elements.linked_item.value
                  const internalLink = item.elements.internal_link.value[0] && item.elements.internal_link.value[0].elements.url_slug.value
                    return <li key={`megamenu_a_${item.id}`} className="nav-links-list__item js-meganav-parent xl:h-full nav-links-list__item--meganav">
                    <span className="js-meganav-trigger xl:!flex xl:items-center xl:h-full">
                      <LinkWrapper url={`/${internalLink}`} cssClass="text-white xl:text-black no-underline" text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} />
                      <span className="mobile-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <g fillRule="nonzero" stroke="#FFF" fill="none">
                            <path d="M.5 7.5h32" strokeLinecap="square" />
                            <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                          </g>
                        </svg>
                      </span>
                    </span>

                    <ul className={`meganav-list ${subItems.length === 2 ? `meganav-list--default` : `meganav-list--fourcol` }`}>
                      <li className="meganav-list__item" key={`megamenu_b_${item.id}`}>
                      <span className="js-nav-back meganav-list__bck-btn">
                        <span className="mobile-arrow">
                          <svg xmlns="http://www.w3.org/2000/svg">
                            <g fillRule="nonzero" stroke="#FFF" fill="none">
                              <path d="M.5 7.5h32" strokeLinecap="square" />
                              <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                            </g>
                          </svg>
                        </span>
                        Back
                      </span>
                      </li>
                      {/* SUB MENUS START */ }
                      {subItems.map((item, i) => {
                        const internalLink = item.elements.internal_link && item.elements.internal_link.value[0] && item.elements.internal_link.value[0].elements && item.elements.internal_link.value[0].elements.url_slug.value
                        const subSubItems = item.elements.linked_item.value
                        const isHorizontal = item.elements.display_preferences.value[0] && item.elements.display_preferences.value[0].codename === "horizontal";
                        const cssClasses = isHorizontal ? "meganav-list__item meganav-list__horizontal" : "meganav-list__item";

                        return  <li key={`megamenu_c_${item.id}`} className={cssClasses}>
                        <p className={i === this.state.megaNavSliderPanelActive ? "text-red font-bold mb-2 text-left font-sans js-meganavlistitem-trigger meganav-list__item-trigger--active" : "text-red font-bold mb-2 text-left font-sans js-meganavlistitem-trigger"} onClick={e => { this.toggleSliderNode(i)}} onKeyDown={e => { this.toggleSliderNode(i)}}>
                          {internalLink ? 
                          <LinkWrapper url={`/${internalLink}`} cssClass="no-underline text-red hover:text-link" text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} /> :
                          item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value
                          }
                        </p>
                        <ul className="meganav-list__sublist-grid">
                        {subSubItems.map((item, i) => {
                          if(item.elements.external_url) {
                            return <li className="leading-7" key={`megamenu_d_${item.id}`}><LinkWrapper cssClass="no-underline text-white xl:text-black hover:text-link" url={`${item.elements.external_url.value}`} text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} /></li>
                          } else {
                            return <li className="leading-7" key={`megamenu_e_${item.id}`}><LinkWrapper cssClass="no-underline text-white xl:text-black hover:text-link" url={`/${item.elements.url_slug.value}`} text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} /></li>
                          }
                        })}
                        </ul>
                      </li>
                      })} 

                      <li key={`megamenu_l_${item.id}`} className="divider"></li>
                      <li key={`megamenu_m_${item.id}`} className="meganav-list__item newsletter">
                      {mailchimp ? (
                          <div
                            className="text-black leading-6 text-center font-sans mailchimp-header"
                            id="newsletterform"
                            dangerouslySetInnerHTML={{ __html: mailchimp }}
                          ></div>
                        ) : (
                          <>
                            <p className="mb-2 font-sans font-bold text-left">Hear more from Pan Macmillan</p>
                            <div className="email-subscription__email-input-container email-subscription--white">
                            <NewsletterHelper
                              id="nav1"
                              newsletterType="best_of_pan_macmillan_newsletter_menu"
                              newsletterLocation="navigation"
                            />
                            </div>
                          </>
                        )}
                    </li>
                    <li key={`megamenu_n_${item.id}`} className="meganav-list__item social">
                      {socialIcons(item)}
                    </li>
                    </ul>
                   
                  </li>
                }  else if(item && item.elements && item.elements.linked_item !== undefined && item.elements.linked_item.value.length > 1) {
                  const subItems = item.elements.linked_item.value
                  return <li key={item.id + i} className="nav-links-list__item js-meganav-parent xl:h-full nav-links-list__item--meganav">
                  <span className="js-meganav-trigger xl:!flex xl:items-center xl:h-full">
                    {item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value}
                    <span className="mobile-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <g fillRule="nonzero" stroke="#FFF" fill="none">
                          <path d="M.5 7.5h32" strokeLinecap="square" />
                          <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                        </g>
                      </svg>
                    </span>
                  </span>
                  <ul className="meganav-list meganav-list--simple">
                    <li key={`megamenu_o_${item.id}`} className="meganav-list__item"><span className="js-nav-back meganav-list__bck-btn">
                      <span className="mobile-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <g fillRule="nonzero" stroke="#FFF" fill="none">
                            <path d="M.5 7.5h32" strokeLinecap="square" />
                            <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                          </g>
                        </svg>
                      </span>
                      Back
                    </span>
                    </li>
                    <li key={`megamenu_p_${item.id}`} className="meganav-list__item">
                    <p className="mb-2 font-sans font-bold text-left meganav-title meganav-title--mobile">
                      {item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value}
                    </p>
                    </li>
                    <li key={`megamenu_q_${item.id}`} className="meganav-list__item">
                      <ul className="meganav-list__sublist meganav-list__sublist--simple meganav-list__sublist--active js-meganavlistitem">
                      {subItems.map((item, i) => {
                        return  item.elements && <li className="leading-7" key={`megamenu_f_${item.id}`}><LinkWrapper url={`/${item.elements.url_slug.value}`} text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} /></li>
                      })}
                      </ul>
                    </li>
                  </ul>
                </li>
                } else if(item && item.system && item.system.type === "template__contributor_list") {
                  return <li key={`megamenu_g_${item.id}`} className="nav-links-list__item js-meganav-parent xl:h-full nav-links-list__item--meganav">
                  <span className="js-meganav-trigger xl:!flex xl:items-center xl:h-full">
                  <LinkWrapper url={`/${item.elements.url_slug && item.elements.url_slug.value}`} cssClass="no-underline text-white xl:text-black hover:text-link" text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} />
                    <span className="mobile-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <g fillRule="nonzero" stroke="#FFF" fill="none">
                          <path d="M.5 7.5h32" strokeLinecap="square" />
                          <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                        </g>
                      </svg>
                    </span>
                  </span>
                  <ul className="meganav-list meganav-list--authors">
                    <li key={`megamenu_r`} className="meganav-list__item">
                      <span className="js-nav-back meganav-list__bck-btn">
                        <span className="mobile-arrow">
                          <svg xmlns="http://www.w3.org/2000/svg">
                            <g fillRule="nonzero" stroke="#FFF" fill="none">
                              <path d="M.5 7.5h32" strokeLinecap="square" />
                              <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                            </g>
                          </svg>
                        </span>
                      Back
                      </span>
                    </li>
                    <li key={`megamenu_s`} className="!col-span-12 meganav-list__item">
                      <p className="col-span-12 mb-2 font-sans font-bold text-left text-[#767676] text-sm lg:text-[17px]">Filter by Surname A - Z <LinkWrapper url={`/authors`} cssClass="meganav-list__view-featured no-underline" text="View Featured Authors" /></p>
                      <ol className="grid gap-2 grid-cols-4 col-span-12 sm:text-left sm:grid-cols-[repeat(26,1fr)] !ml-0 !list-none">
                          {alphabet.map((value, index) => {
                            return (
                              <li key={`megamenu_t_${value}`} className="font-sans text-2xl uppercase transition-all js-alphabet hover:scale-105">
                                <LinkWrapper url={`/contributors/${value}`} cssClass="text-white sm:text-red no-underline" text={value} />
                              </li>
                            )
                          })}
                      </ol>
                    </li>
                    {featuredContributors && featuredContributors.length > 0 && 
                    <>
                    <li key={`megamenu_u`} className="divider !col-span-12"></li>
                    <li key={`megamenu_v`} className="meganav-list__item !col-span-12">
                      <p className="mb-2 font-sans font-bold text-left">{featuredContributorsHeading ? featuredContributorsHeading : `Featured Contributors`}</p>
                      <ul className="featuredcontributors-list">
                      {featuredContributors.map((item) => {
                        const kontentImage = item.elements && item.elements.image && item.elements.image.value && item.elements.image.value[0];
                            return (
                              <li className="w-full" key={`megamenu_w_${item.id}`}>
                                <Link to={`/${item.elements.link_url.value}`}>
                                  <ImageElement
                                    image={kontentImage}
                                    alt={kontentImage.description ? kontentImage.description : kontentImage.name}
                                    width={kontentImage.width}
                                    height={kontentImage.height}
                                    className="w-full"
                                  />
                                </Link>
                                <LinkWrapper cssClass="no-underline text-white lg:text-black hover:text-link" url={`/${item.elements.link_url.value}`} text={item.elements.name.value} />
                              </li>
                            )
                          })}
                      </ul>
                    </li>
                    </>
                    }
                  </ul>
                </li>
                } else if(item && item.system && item.system.type === "template__article_list") {
                  return <li key={`megamenu_h_${item.id}`} className="nav-links-list__item js-meganav-parent xl:h-full nav-links-list__item--meganav">
                  <span className="js-meganav-trigger xl:!flex xl:items-center xl:h-full">
                  <LinkWrapper url={`/${item.elements.url_slug && item.elements.url_slug.value}`} text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} cssClass="no-underline"  />
                    <span className="mobile-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <g fillRule="nonzero" stroke="#FFF" fill="none">
                          <path d="M.5 7.5h32" strokeLinecap="square" />
                          <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                        </g>
                      </svg>
                    </span>
                  </span>
                  <ul className="meganav-list meganav-list--articles">
                    <li  key={`megamenu_x`} className="meganav-list__item"><span className="js-nav-back meganav-list__bck-btn">
                      <span className="mobile-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <g fillRule="nonzero" stroke="#FFF" fill="none">
                            <path d="M.5 7.5h32" strokeLinecap="square" />
                            <path d="M33.157 7.5l.353-.354-.353.354.353.354-.353-.354zm0 0l-6.01 6.01 6.01-6.01-6.01-6.01 6.01 6.01z" />
                          </g>
                        </svg>
                      </span>
                      Back
                    </span>
                    </li>
                    <li  key={`megamenu_y`} className="meganav-list__item categories">
                    <p className="mb-2 font-sans font-bold text-left">Explore articles by genre</p>
                    <ul className="meganav-list--categories">
                      {articleCategories.map((item, i) => {
                        return <li key={`megamenu_z_${item.elements.url_slug.value}`} className="leading-7"><LinkWrapper url={`/${item.elements.url_slug.value}`} cssClass="text-white xl:text-black no-underline hover:text-link" text={item.elements.title.value} /></li>
                      })}
                    </ul>
                    {dontmissNavigationItems && dontmissNavigationItems.length > 0 &&  dontMissBlock() }
                    </li>
                    <li key={`megamenu_aa`} className="meganav-list__item popular">
                      <p className="mb-2 font-sans font-bold text-left">Latest</p>
                      <LatestArticles />
                    </li>
                    <li key={`megamenu_ab`} className="divider"></li>
                    <li key={`megamenu_ac`} className="meganav-list__item newsletter">
                        {mailchimp ? (
                          <div
                            className="text-black leading-6 text-center font-sans p-6 sm:p-10 w-full border-t border-[#ccc] max-w-[880px] ml-auto mr-auto"
                            id="newsletterform"
                            dangerouslySetInnerHTML={{ __html: mailchimp }}
                          ></div>
                        ) : (
                          <>
                            <p className="mb-2 font-sans font-bold text-left">Hear more from Pan Macmillan</p>
                            <div className="email-subscription__email-input-container email-subscription--white">
                            <NewsletterHelper
                              id="nav1"
                              newsletterType="best_of_pan_macmillan_newsletter_menu"
                              newsletterLocation="navigation"
                            />
                            </div>
                          </>
                        )}
                    </li>
                    <li key={`megamenu_ad`} className="meganav-list__item social">
                      {socialIcons(item)}
                    </li>
                  </ul>
                </li>
                } else if(item && item.system && item.system.type === "navigation_item" && item.elements.external_url.value != null) {
                  return <li className="nav-links-list__item xl:h-full" key={`megamenu_i_${item.id}`}><span className="xl:!flex xl:items-center xl:h-full"><LinkWrapper url={`${item.elements.external_url.value}`} cssClass="no-underline" text={item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item.elements.title.value} /></span></li>
                }
                return <li className="nav-links-list__item xl:h-full" key={`megamenu_j_${item && item.id}`}><span className="xl:!flex xl:items-center xl:h-full"><LinkWrapper url={`/${item && item.elements && item.elements.url_slug.value}`} cssClass="no-underline" text={item && item.elements && item.elements.short_title && item.elements.short_title.value ? item.elements.short_title.value : item && item.elements && item.elements.title.value} /></span></li>
              })}
            </ul>
          </li>
          <SearchBar></SearchBar>
          <li key={`megamenu_i`} className="nav-list__mobile-trigger js-mobile-toggle" onClick={this.toggleMobileMenu} onKeyDown={this.toggleMobileMenu}>
            <span className="menu-link">
              Menu
              <span className="lines">
                <span className="middle"></span>
              </span>
            </span>
          </li>
        </ul>
        </div>
    </nav>
    )
  }
}

export default MegaMenu
